import { render, staticRenderFns } from "./BlackPlaceOrderSuccessV2.vue?vue&type=template&id=7fe4cc20&scoped=true"
import script from "./BlackPlaceOrderSuccessV2.vue?vue&type=script&lang=js"
export * from "./BlackPlaceOrderSuccessV2.vue?vue&type=script&lang=js"
import style0 from "./BlackPlaceOrderSuccessV2.vue?vue&type=style&index=0&id=7fe4cc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe4cc20",
  null
  
)

export default component.exports